
type Props = {}

const PageSecurity = (props: Props) => {
  return (
    <div>PageSecurity</div>
  )
}

export default PageSecurity